/*
Responsive videos in deltails panel and media slider
*/
$('.detail-panel, .type-video-external').fitVids();

/*
Options
*/
if ($b.hasClass('template-product')) {

  var delimiter = '_';
  var $variantSelect = $('#variant-select');
  var $allOptions = $variantSelect.find('option');
  var $addToCart = $('#add-to-cart');
  var groupSelector = '.option-group';
  var $wishlistBtn = $('.iWishAdd');
  // var updateStockMessage = function(variantId){
  //   $('.pdp-message.stock .status').text(shippingMessaging[variantId].status);
  //   $('.pdp-message.stock .message').text(shippingMessaging[variantId].message);
  //   $('#itemprop-shipping-promise').val(shippingMessaging[variantId].message);
  //   $('#itemprop-shipping-promise-code').val(shippingMessaging[variantId].code);
  // };
  var makeHandle = function(str){
    return str.toLowerCase()
      .replace(/ /g,'-') // convert spaces to dashes
      .replace(/---/g,'-') // --- can happen when there's a dash already in the string
      .replace(/[\.\/]/g,'-') //  convert . and / to -
      .replace(/[^a-z0-9\-]/g,''); // alpha numeric and - allowed, rest removed
  }
  var updateMeta = function(value, $visibleEl, $itemPropEl){
    if (value) {
      if ($visibleEl) {
        $visibleEl.text(value).show();
        $visibleEl.closest('li').show();
      }
      if ($itemPropEl){
        $itemPropEl.val(value).trigger('change');
      }
    }else{
      if ($visibleEl) {
        $visibleEl.hide();
        $visibleEl.closest('li').hide();
      }
      if ($itemPropEl){
        if ($itemPropEl.val() != '') {
          $itemPropEl.val('').trigger('change');
        }
      }
    }
  };

  var selectOption = function($group, value){
    if ($group.find('.swatches').length) {
      $group.find(`[data-value="${makeHandle(value)}"]`).click();
    } else {
      $group.find('select.option').val(makeHandle(value)).trigger('change');
    }
  };

  var handleUnlistedSku = function(mustContact, finderSelection){
    let $elementsToHide = $('#qty-row, #product-form .actions, #pdp-messages');
    let finderData = finderSelection ? JSON.parse(finderSelection).data : null;

    // always clear the previous message in case a new one needs to be shown, or because we're showing the regular form stuff again
    $('#unlisted-message').remove();

    if (mustContact === 'true') {
      let canShowMessage = true;
      let selectedOptions = [];
      let firearmInfo = [];
      $('.option-group').each(function(){
        let groupTitle = $(this).find('.title').html().split('<'); // strip out info icon text
        selectedOptions.push(`${groupTitle[0].trim()}: ${$(this).find('.option-input:selected').text()}`);
      });
      if (window.isHolster) {
        if (finderData && finderData.gun) {
          firearmInfo.push(`Firearm: ${finderData.gun.manufacturer} ${finderData.gun.model} (${finderData.gun.barrel} Barrel Length, ${finderData.gun.caliber} Caliber)`);
          if (finderData.details) {
            if (finderData.details.lightName) firearmInfo.push(`Light: ${finderData.details.lightName}`);
            if (finderData.details.opticName) firearmInfo.push(`Optic: ${finderData.details.opticName}`);
          }
        } else {
          canShowMessage = false; // haven't been through the finder, won't have enough information to show and we want to keep the "check fit" shown
        }
      }
      let msg = `<div id="unlisted-message" class="alert alert-warning">
        <p>This configuration is not available online, but you can still order it by sending us the following details using the button below.</p>
        <form action="${window.cmsHost}/custom-product-order-form/" method="post" target="_blank">
          <input name="ptitle" type="hidden" value="${$('h1.title').text()}" />
          <input name="pdetails" type="hidden" value="${selectedOptions.join('\r\n')}" />
          <input name="fdetails" type="hidden" value="${firearmInfo.join('\r\n')}" />
          <button type="submit" class="btn btn-enhanced">Order Form${window.app.btnBorder}</button>
        </form>
      </div>`;
      if (canShowMessage) {
        $('#product-form').addClass('no-submit'); // prevent submit with keyboard
        $elementsToHide.hide();
        $(msg).insertAfter('#product-form');
      }
    } else {
      // protect against .no-submit getting removed when the variant meta doesn't include a must-contact flag and the product is not for sale onsite
      if( $('#product-form').hasClass('must-find-dealer') || $('#product-form').hasClass('must-buy-offsite') ){
        return;
      }
      $('#product-form').removeClass('no-submit');
      $elementsToHide.show();
    }
  };

  var enableAddToCart = function() {
	$addToCart.attr('disabled', false).html('Add to cart' + window.app.btnBorder);
  };

  var disableAddToCart = function() {
	$addToCart.attr('disabled', true);
	if ($('.product-options .option-group').length) {
		let text = 'Add to cart';
		$('.product-options .option-group').each(function(){
			if (! $(this).find('.option').val()) {
				text = `Select ${$(this).find('.title')[0].childNodes[0].nodeValue}`; // jquery .text() will grab text from child elements too
				return false;
			}
		});
		$addToCart.html(`${text} ${window.app.btnBorder}`);
	}
  };

  var clearMetas = function () {
    var shippingKey = window.shippingMessageKey;
	disableAddToCart();
    $wishlistBtn.attr('disabled', true).text(iwish_add_txt).removeClass('iwishAdded');
    updateMeta('', $('#product-meta-sku'), $('#itemprop-sku'));
    updateMeta('', $('#product-meta-model'), $('#itemprop-model'));
    updateMeta('', $('#product-meta-part'), $('#itemprop-part'));
    updateMeta('', null, $('#itemprop-quickship'));
    updateMeta('', null, $('#itemprop-lastchance'));
    updateMeta('', null, $('#itemprop-promotion'));
    updateMeta(window.storeShippingMessages[shippingKey].status, $('.pdp-message.stock .status'), null);
    updateMeta(window.storeShippingMessages[shippingKey].message, $('.pdp-message.stock .message'), $('#itemprop-shipping'));
    updateMeta('', null, $('#itemprop-shipping-days'));
  };

  var dynamicOptions = null;
  var dynamicOptionChoices = null;
  var dynamicVariants = null;
  var selectedDynamicVariant = null;

  var haveGunId = false;
  var commsSelection = localStorage.getItem('comms_configurator_selections');
  var partNumber = window.helpers.getUrlParameter('part-number');

  // finder selections can exclude certain colors on the PDP.
  // when we have a part number that maps to an excluded color, we won't be able to find its variant, leading to a price range display
  // this causes a problem with google because products they display in search results must lead to PDPs with the same price shown
  // so, part numbers in the URL now reset your finder choices.
  if (partNumber) {
	localStorage.removeItem('holster_finder_selections');
  }

  var getFinderSelections = function(){
    return localStorage.getItem('holster_finder_selections');
  };

  var getApiEndpoint = function() {
    let endpoint = window.apiHost;
    let finderSelection = getFinderSelections();
    if (window.isHolster) {

      haveGunId = false;
      endpoint += '/holsters/configurations/' + window.productHandle;

      // if we've visited the holster finder, only get the options for our gun
      if (finderSelection) {
        var selections = JSON.parse(finderSelection);
        if (selections.data && selections.data.gun) {
          haveGunId = true;
          endpoint += '/gun/' + selections.data.gun.id;
          if (selections.data.details !== null) {
            // optics and light will change the SKU, just like the gun ID
            var optic = selections.data.details.optic !== null ? selections.data.details.optic : '';
            var light = selections.data.details.light !== null ? selections.data.details.light : '';
            endpoint += '?optic=' + optic + '&light=' + light;
          } else if (selections.data.partNumber !== null) {
            // if you've searched by partnumber, optics and light are baked into the results
            endpoint += '?partNumber=' + selections.data.partNumber;
          }
        }
      }

      // if we haven't visited the finder, but we're being asked for a specific part number,
      // limit the dropdown options to just those that match the part number
      if (partNumber && !haveGunId) {
        endpoint += '?partNumber=' + partNumber;
      }

    }

    if (window.isComms) {
      endpoint += '/comms/configurations/' + window.productHandle;
    }

    return endpoint;
  }

  var loadDynamicVariantData = function () {
    $.ajax({
      url: getApiEndpoint(),
      success: function(response, textStatus, jqXHR ){

        // clean the slate
        $('#options').html('');
        $('#dynamic-options-select').html('');
        $('#product-form').removeClass('disabled');

        dynamicOptions = response.data.attributes;

        if (window.isHolster) {
          dynamicVariants = response.data.holsters;
        }
        if (window.isComms) {
          dynamicVariants = response.data.comms;
        }

        // empty results happen when:
        // -- you've been through the finder and are viewing an incompatible holster
        // -- some other handle error
        if (!dynamicOptions.length && !dynamicVariants.length) {
          $('#product-form').addClass('disabled');
          return;
        }

        let groups = {};
        let configurations = [];
        let i = 0;
        // build option groups
        for (let [optionKey, optionName] of Object.entries(dynamicOptions)) {
          let displayOptionName = optionName;
          if (optionName === 'Suspension') {
            // Special handling for suspension option name on PDP
            displayOptionName = 'Adaptive Suspension';
          }
          let markup = window.defaultGroup.replace('{groupname}',displayOptionName);
          if (optionName === 'Color') {
            markup = window.colorGroup;
          }
          if (optionName === 'Size') {
            markup = window.sizeGroup;
          }
          markup = markup.replace(/\{index\}/g, i);
          markup = markup.replace(/\{handle\}/g, optionKey);
          $('#options').append(markup);
          groups[optionKey] = [];
          i++;
        }

        // populate option groups
        let optionData = {};
        let hasQuickShipVariant = false;
        for (let c = 0; c < dynamicVariants.length; c++) {
			if (!dynamicVariants[c]['is_in_stock']) continue;
			let combinedValues = [];
			// loop through the options we care about
			for (let [optionKey, optionName] of Object.entries(dynamicOptions)) {
				// get the value of that option for this product
				let value = dynamicVariants[c][optionKey];
				// edge case when the value is null
				if (!value) {
				continue;
				}
				let handle = makeHandle(value);
				// if we haven't already added this value to this option group, add it
				if (!groups[optionKey].includes(value)) {

				if (!optionData[optionKey]) {
					optionData[optionKey] = {
					key: optionKey,
					name: optionName,
					values: []
					};
				}
				optionData[optionKey].values.push({
					value: value,
					handle: handle
				});

				// add this value to the groups so it doesn't get added again
				groups[optionKey].push(value);
				}
				// build up this configuration
				combinedValues.push(handle);
			}

			let configurationStr = combinedValues.join(delimiter);
			if (!configurations.includes(configurationStr)) {
				$('#dynamic-options-select').append('<option value="' + configurationStr + '" data-price="' + dynamicVariants[c]['price'] + '" data-variant-id="' + dynamicVariants[c]['product_id'] + '">' + configurationStr + '</option>');
				configurations.push(configurationStr);
			}

			let _allowed = dynamicVariants[c]['allowed_shopify_add_on_variant_ids'].split(',');
			_allowed = _allowed.map(a => {
				// Make sure our list only includes trimmed strings
				return (a === null) ? '' : (a+'').trim();
			}).filter(a => {
				// Make sure our list doesn't include any empty strings
				return (a !== '');
			});
			allowedAddOnVariantIds[dynamicVariants[c]['product_id']] = (_allowed.length) ? _allowed : null;
			if (dynamicVariants[c]['quick_ship'] === 1) {
				hasQuickShipVariant = true;
			}
        }

        // show the badge if any variant is quick ship
        $('#quick-ship-badge').hide();
        if (hasQuickShipVariant) {
          $('#quick-ship-badge').show();
        }

        // Now populate the DOM elements
        i = 0;
        for (let [_optionKey, _optionData] of Object.entries(optionData)) {

          let optionKey = _optionData.key;
          let optionName = _optionData.name;

          // Sort YES/NO options with YES first
          if (['gas_mask_input', 'gas_mask_cable', 'cell_phone', 'volume_control', 'race'].includes(optionKey)) {
            _optionData.values.sort((a, b) => {
              let _a = a.value.toUpperCase();
              let _b = b.value.toUpperCase();
              if (_a < _b) { return 1; }
              if (_a > _b) { return -1; }
              return 0;
            });
          }

          _optionData.values.forEach(valueObj => {

            let value = valueObj.value;
            let displayValue = value;
            let handle = valueObj.handle;

            // insert the UI element
            let mkImg = '';
            let mkTooltip = '';
            let classes = 'swatch';
            let $group = $('[data-option-handle="' + optionKey + '"]');
            if (optionName === 'Color') {
              mkImg = ' style="background-image: url(' + holster_finder_cdn_url + 'swatch-' + handle + '.png?v=2)"';
              mkTooltip = ' title="' + value + '" data-toggle="tooltip"';
              classes += ' is-color';
            }
            if (optionName === 'Color' || optionName === 'Size') {
              $group.find('.swatches').append('<a href="#" class="' + classes + '" data-value="' + handle + '" tabindex="-1" disabled' + mkImg  + mkTooltip + '><span class="label-text">' + value + '</span></a>');
            }

              // Impedance needs to be displayed slightly differently from the actual data
              if (optionKey == 'impedance') {
                displayValue = displayValue.replace('CIVILIAN', 'LE/CIVILIAN');
              }

            // add it to the select
            $('#option-' + i).append('<option class="option-input" value="' + handle + '" disabled>' + displayValue + '</option>');

          });

          i++;
        }

        // clean up
        $('#options [value="value"]').remove();
        $('#options .options [data-value="value"]').closest('li').remove();
        $('#options .swatches [data-value="value"]').remove();

        $b.trigger('data-ready');

        autoSelectDynamicVariants(groups, dynamicVariants);
      }
    });
  };

  var autoSelectDynamicVariants = function (groups, dynamicVariants) {
    if (window.isHolster && partNumber){
      var keys = Object.keys(groups);
      // enable checkout and bypass the finder when we have a part number
      // this assumes the user knows what they're doing and don't need to verify fit with their gun
      $.ajax({
        method: 'POST',
        url: window.apiHost + '/holsters/search',
        data: {
          partNumber: partNumber
        },
        success: function(result,status,xhr){
          if (result.data.length) {
            // we have a match, select the options
            keys.forEach(key => {
              selectOption($(`[data-option-handle="${key}"]`), result.data[0][key]);
            });
          } else {
            // didn't find a match (unlikely), try to select anyway
            for (let index = 0; index < dynamicVariants.length; index++) {
              const element = dynamicVariants[index];
              if (element.legacy_part_number == partNumber) {
                keys.forEach(key => {
                  selectOption($(`[data-option-handle="${key}"]`), element[key]);
                });
                break;
              }
            }
          }
        },
        error: function(xhr,status,error){
          console.log(status, error);
        }
      });

      // all done
      return;
    }

    var selections = JSON.parse(commsSelection);

    // Stop if we aren't coming from the comms builder
    if (!window.helpers.getUrlParameter('comms-builder')) {
      return;
    }

    if (selections.data.headsetDetails) {
      if (!selections.data.headsetDetails.rail) {
        selections.data.headsetDetails.rail = 'NO';
      }
    }

    if (selections.data.systemDetails) {

      // The "radio1" selection actually corresponds to the "radio" PDP attribute
      selections.data.systemDetails.radio = selections.data.systemDetails.radio1;

      // The "radio2" selection actually corresponds to the "radio_2" PDP attribute
      selections.data.systemDetails.radio_2 = selections.data.systemDetails.radio2;

      // For these yes/no fields, make sure they have a value in the selections
      if (!selections.data.systemDetails.gas_mask_input) {
        selections.data.systemDetails.gas_mask_input = 'NO';
      }
      if (!selections.data.systemDetails.gas_mask_cable) {
        selections.data.systemDetails.gas_mask_cable = 'NO';
      }
      if (!selections.data.systemDetails.cell_phone) {
        selections.data.systemDetails.cell_phone = 'NO';
      }
      if (!selections.data.systemDetails.volume_control) {
        selections.data.systemDetails.volume_control = 'NO';
      }
      if (!selections.data.systemDetails.race) {
        selections.data.systemDetails.race = 'NO';
      }

    }

    for (let [optionKey, optionValue] of Object.entries(groups)) {
      let selectionValue = null;
      if (selections.data[optionKey]) {
        selectionValue = selections.data[optionKey];
      }
      if (selections.data.headsetDetails && selections.data.headsetDetails[optionKey]) {
        selectionValue = selections.data.headsetDetails[optionKey];
      }
      if (selections.data.systemDetails && selections.data.systemDetails[optionKey]) {
        selectionValue = selections.data.systemDetails[optionKey];
      }
      if (!selectionValue) {
        continue;
      }

      // set the value
      selectOption($(`[data-option-handle="${optionKey}"]`), selectionValue);
    }
  };

  // set inital state once options are ready
  $b.on('data-ready', function(){

	if ($('.product-options .option').length) {
		disableAddToCart();
	}

    // use dynamic configurations rather than what shopify outputs from variants
    if (window.useDynamicVariants) {
      $allOptions = $('#dynamic-options-select').find('option');
      clearMetas();
    }

    var $firstGroup = $('[data-option-index="0"]');

    // enable first group's options on load
    $allOptions.each(function(){
      var optionParts = $(this).text().trim().split(delimiter);
      // get the element with that value that matches the first part of an option name
      // enable options in the select
      $firstGroup.find('[value="' + optionParts[0] + '"]').prop('disabled', false);
      // enable swatches
      $firstGroup.find('[data-value="' + optionParts[0] + '"]').attr('disabled', false).attr('tabindex', '0');
    });

    // enable tooltips
    $('[data-toggle="tooltip"]').tooltip();

    // auto-select the first group if there's only one color (uncommon)
    // this can happen when you're on a holster after going through the finder
    // and your firearm reduces the color options down to a single choice.
    var $colors = $firstGroup.find('.swatch');
    if ($colors.length === 1) {
      $colors.first().click(); // first() is unnecessary here but it reads better
    }

  });

  $b.on('data-reload', function (){
    loadDynamicVariantData();
  });

  /*
  Build options for dynamic price-based variants
  */
  if (!window.useDynamicVariants) {

    // Customize the display of the "Suspension" option
    $(groupSelector).each(function() {
      let $label = $(this).find('label');
      if (($label.length > 0) && ($label.text().trim() == 'Suspension')) {
        $label.text('Adaptive Suspension');
      }
    });

    // no ajax-y business to do, ready to go
    $b.trigger('data-ready');
  } else {
    loadDynamicVariantData();
  }

  // swatch click
  $b.on('click', '.swatch', function(e){
    e.preventDefault();
    // pick new option
    let $group = $(this).closest(groupSelector);
    $group.find('.swatch').removeClass('selected');
    $(this).addClass('selected').blur();
    $group.find('.option').val($(this).data('value')).trigger('change');
    // update images
    if ($(this).hasClass('is-color') ){
      // can't do this cleanup in in the template because it breaks the connection to the hidden select
      let cleanedValue = $(this).data('value').replace('™','').replace('®','');
      let $mediaThumb = $('.thumb[data-for-color="'+ cleanedValue +'"]').first();
      if ($mediaThumb.length && !$mediaThumb.hasClass('active')) {
        $mediaThumb.click();
      }
    }
  });

  // swatch or dropdown click triggers a change to the hidden select for that group
  $b.on('change', '.option', function(){

    // Skip all this if the click was in an add-on option
    if ($(this).closest('.add-on-group').length) {
      return;
    }

    let value = $(this).val();
    let $group = $(this).closest(groupSelector);
    let $nextAll = $group.nextAll(groupSelector);

    // maybe update images
    if ($group.data('option-handle') === 'finish') {
      // only change the image when we have a color + finish match
      let activeColor = $('.thumb.active').data('for-color');
      let $mediaThumb = $('.thumb[data-for-color="'+ activeColor +'"][data-for-finish="'+ value +'"]').first();
      if ($mediaThumb.length && !$mediaThumb.hasClass('active')) {
        $mediaThumb.click();
      }
    }

    // reset downstream groups
    $variantSelect.val('').trigger('change');
    $nextAll.data('value', '');
    // reset swatches
    $nextAll.find('.swatch').attr('disabled', true).attr('tabindex', '-1').removeClass('selected');
    // reset selects, visible and hidden
    $nextAll.find('.option-input').prop('disabled', true);
    $nextAll.find('select').val('');
    $nextAll.find('.property-field').val('');

	disableAddToCart();

    // store what we just selected
    $group.data('value', value);

    // what have we selected so far
    let selectedPath = [];
    $(groupSelector).each(function(){
      if ($(this).data('value')){
        selectedPath.push($(this).data('value'));
      }
    });

    // what still matches our selection in the hidden select
    let remainingOptions = [];
    $allOptions.each(function(){
      let optionText = $(this).text().trim();
      if ((optionText+delimiter).includes(selectedPath.join(delimiter)+delimiter) ){
        remainingOptions.push(optionText);
      }
    });

    // by now, we have a list of potential options still available by comparing all options against what we've selected
    // for the next group, look at each option. If its value matches the text at the same position in one of the still-possible options, enable it.
    var $nextGroup = $group.next(groupSelector);
    $nextGroup.find('.option-input').each(function(){
      for (let index = 0; index < remainingOptions.length; index++) {
        let optionParts = remainingOptions[index].split(delimiter);
        if (optionParts[$(this).closest(groupSelector).data('option-index')] === $(this).val()){
          $(this).prop('disabled', false); // selects
          $(this).closest(groupSelector).find('[data-value="' + $(this).val() + '"]').attr('disabled', false).attr('tabindex', '0'); // swatches
        }
      }
    });

    // auto-select a choice when it's the only available/enabled option
    let $nextGroupOptions = $nextGroup.find('.option-input').not('[disabled]');
    if ($nextGroupOptions.length === 1) {
      let value = $nextGroupOptions.attr('value');
      if ($nextGroup.find('.swatches').length) {
        $nextGroup.find(`[data-value="${value}"]`).click(); // auto select a swatch (uncommon)
      } else {
        $nextGroup.find('.option').val(value).trigger('change'); // set the select value to the only possible option
      }
      return; // bail to send us back down the option stack
    }

    // all done?
    if (selectedPath.length === $(groupSelector).length ){

      // for each option in the hidden select
      $allOptions.each(function(){
        // ... find the option text that matches our selections path
        if (selectedPath.join(delimiter) === $(this).text().trim()){
			// for finder products, just match the selected product price against the hidden select's options
			// option names should be price * 100
			if (window.useDynamicVariants) {
				let $dynamicOption = $(this);
				$variantSelect.find('option').each(function(){
					if (($(this).text() * 1 === Math.round($dynamicOption.data('price') * 100)) || ($(this).text().trim() === 'default-title')) {
						selectedDynamicVariant = $dynamicOption.data('variant-id');
						$variantSelect.val($(this).val()).trigger('change');
						return true;
					}
				});
		} else {
			// ... if that option isn't disabled/out of stock
			if (!$(this).prop('disabled')) {
				$variantSelect.val($(this).val()).trigger('change');
			} else {
				// stock message no longer responds to variant changes
				// updateStockMessage($(this).val());
			}
          }
        }
      });
    }

    // If we just selected a PTT for a comms product...
    if ($group.data('option-handle') === 'ptt_type') {

      if (window.commsImages[value]) {
        $('#pdp-main .media-slider').hide();
        $('#pdp-main .media-thumbs').hide();
        $('#pdp-main .media .comms-image').remove();
        $('#pdp-main .media').append($('<img class="comms-image" alt="" width="600" src="'+commsImages[value]+'">'));
      }

      // And hide/show gas mask fields
      if (value == 'alpha') {

        // Hide gas_mask_input
        $('[data-option-handle="gas_mask_input"]').hide();
        $('[data-option-handle="gas_mask_input"]').data('skipped', true);

        // Show gas_mask_cable
        $('[data-option-handle="gas_mask_cable"]').show();
        $('[data-option-handle="gas_mask_cable"]').data('skipped', false);
      }
      if (value == 'delta') {

        // Hide gas_mask_cable
        $('[data-option-handle="gas_mask_cable"]').hide();
        $('[data-option-handle="gas_mask_cable"]').data('skipped', true);

        // Show gas_mask_input
        $('[data-option-handle="gas_mask_input"]').show();
        $('[data-option-handle="gas_mask_input"]').data('skipped', false);
      }

    }

    // Automatically select "NO" option for hidden gas mask fields
    ['gas_mask_input', 'gas_mask_cable'].forEach(field => {
      if ($group.data('option-handle') != field) {
        if ($('[data-option-handle="'+field+'"]').length &&
            $('[data-option-handle="'+field+'"]').data('skipped') &&
            ($('[data-option-handle="'+field+'"]').data('option-index') > $group.data('option-index'))) {
          $('[data-option-handle="'+field+'"] a[data-value="' + makeHandle('NO') + '"]').click();
        }
      }
    });

  });

  $variantSelect.on('change', function(){
    // product-level shipping message
    var shippingKey = window.shippingMessageKey;

    // was a reset, don't do anything else
    if (!$(this).val()) {
      clearMetas();
      return;
    }

    // get new variant data
    var _variants = window.variants;
    for (let index = 0; index < _variants.length; index++) {
      if (_variants[index].id == $(this).val()) {
        currentVariant = _variants[index];
      }
    }
    var sku = currentVariant.sku;
    var model = variantMeta[currentVariant.id].model;
    var part = variantMeta[currentVariant.id].part;
    var quickShip = variantMeta[currentVariant.id].quickShip;
    var lastChance = variantMeta[currentVariant.id].lastChance;
    var promotion = variantMeta[currentVariant.id].promotion;
    var addOnVariantId = currentVariant.id;

    // variant shipping message key overrides parent, maybe
    shippingKey = variantMeta[currentVariant.id].shippingMessageKey || shippingKey;

    let dynamicVariant = null;
    if (window.useDynamicVariants) {
      // default to using the lookup when we have a gun
      // there will be one holster in variants with the particular configuration we've selected
      let filterResults = dynamicVariants.filter(variant => {
        return (variant.product_id == selectedDynamicVariant);
      });
      // when we do a part search, we may not have a gun
      // if we don't have a gun, then our dynamic variants can have several option configurations with the same choices (multiple SKUs with Black/Right/STX Tactical, etc)
      // when that happens, the first dynamic variant that matches our pre-selected choices gets picked using the method above, which may not match the actual part
      // so, ensure that we're matching on the part number to get the correct SKU, but only when we don't have the gun, otherwise the part number won't change
      if (partNumber && !haveGunId) {
        filterResults = dynamicVariants.filter(variant => {
          return (variant.legacy_part_number == partNumber);
        });
      }
      dynamicVariant = filterResults[0];
      sku = dynamicVariant.product_id;
      part = dynamicVariant.legacy_part_number;
      model = dynamicVariant.model;
      quickShip = dynamicVariant.quick_ship;
      lastChance = dynamicVariant.last_chance;
      promotion = dynamicVariant.promotion;

      // prevent data display when we haven't gone through the finder or have a part number from a search
      if (window.isHolster && !haveGunId && !partNumber) {
        sku = null;
        part = null;
      }

      addOnVariantId = dynamicVariant.product_id;

      // dynamic variant shipping message key overrides parent, maybe
      shippingKey = dynamicVariant.shipping_message || shippingKey;

      // passing in must_contact values as string to match how metafields output booleans
      $mustContact = dynamicVariant.must_contact_to_order ? 'true' : 'false';
      handleUnlistedSku($mustContact, getFinderSelections());
    } else {
      handleUnlistedSku(window.variantMeta[currentVariant.id].mustContactToOrder, null);
    }


    // get the message object (a store ACF json field) for this key
    if (window.storeShippingMessages.hasOwnProperty(shippingKey)) {
      shipping = window.storeShippingMessages[shippingKey];
    } else {
      shipping = window.storeShippingMessages.default;
    }

    updateMeta(sku, $('#product-meta-sku'), $('#itemprop-sku'));
    updateMeta(model, $('#product-meta-model'), $('#itemprop-model'));
    updateMeta(part, $('#product-meta-part'), $('#itemprop-part'));
    updateMeta(quickShip, null, $('#itemprop-quickship'));
    updateMeta(lastChance, null, $('#itemprop-lastchance'));
    updateMeta(promotion, null, $('#itemprop-promotion'));
    updateMeta(shipping.status, $('.pdp-message.stock .status'), null);
    updateMeta(shipping.message, $('.pdp-message.stock .message'), $('#itemprop-shipping'));
    updateMeta(shipping.days, null, $('#itemprop-shipping-days'));

    // update Price
    let variantCompareAtPrice = null;
    let variantPrice = currentVariant.price;
    if (currentVariant.compare_at_price) {
      variantCompareAtPrice = currentVariant.compare_at_price;
    }
    if (dynamicVariant && dynamicVariant.compare_at_price) {
      variantCompareAtPrice = Math.round(dynamicVariant.compare_at_price * 100);
    }
    if (variantCompareAtPrice && variantCompareAtPrice > variantPrice){
      priceHtml = '<span class="sale-price">' + window.helpers.formatPrice(variantPrice) + '</span><span class="regular-price">' + window.helpers.formatPrice(variantCompareAtPrice) + '</span>';
    }else{
      priceHtml = window.helpers.formatPrice(variantPrice);
    }
    $('.price-bar .price').html(priceHtml);
    $('#qty-row .price').html(priceHtml);

    // hide/show Last Chance flag
    if (lastChance){
      $('.pdp-message.last-chance').show();
    } else {
      $('.pdp-message.last-chance').hide();
    }

    // hide/show Quick Ship badge
    if (quickShip){
      $('#quick-ship-badge').show();
    } else {
      $('#quick-ship-badge').hide();
    }

    // maybe show a bespoke variant image
    // variantImage is null when empty,
    // variantResizedImages is always there in the data, but the values for each image will be the shopify no-image placeholder when variantImage is null
    let variantImage = currentVariant.featured_image;
    if (variantImage) {
        let variantResizedImages = variantMeta[currentVariant.id].images;
        let markup = `<div class="item zoom is-variant-image" data-src="${variantImage.src}">
        <picture>
          <source srcset="${variantResizedImages.lg}, ${variantResizedImages.lg2x} 2x" media="(min-width: 1025px)">
          <img src="${variantResizedImages.xs}" alt="${variantResizedImages.alt}" width="414" height="414">
        </picture>
      </div>`;
      $('.media .is-variant-image').remove();
      $('.media').prepend(markup);
      $('.media-slider').hide();
      $('.media-thumbs .thumb').removeClass('active');
    }


    // only used for holsters
    if( $('#itemprop-options').length ){
      var selections = JSON.parse(getFinderSelections());
      var options = [];
      var gunOptions = [];
      if (selections && selections.data.gun) {
        delete selections.data.gun.holsters;
		$('#itemprop-gun').val(`${selections.data.gun.manufacturer} ${selections.data.gun.model}`);
        $('#itemprop-gun-data').val(JSON.stringify(selections.data));
        gunOptions.push(`Firearm:${selections.data.gun.manufacturer} ${selections.data.gun.model} (${selections.data.gun.barrel} Barrel Length, ${selections.data.gun.caliber} Caliber)`);
        if (selections.data.details.lightName) {
          gunOptions.push(`Light:${selections.data.details.lightName}`);
        }
        if (selections.data.details.opticName) {
          gunOptions.push(`Optic:${selections.data.details.opticName}`);
        }
        $('#itemprop-gun-options').val(gunOptions.join('|'));
      }
      $('.option-group').each(function(){
        var title = $(this).find('.title').ignore('a').text().trim();
        var value = $(this).find('select').val();
        var valueLabel = $(this).find(`[value="${value}"]`).text();
        options.push(title + ':' + valueLabel);
      });

      let choices = options.join('|');
      $('#itemprop-options').val(choices);

      // if we don't have a gun and we do have a part number, we have to send the user back through the finder to confirm the fit after selections change
      if (dynamicOptionChoices !== null && dynamicOptionChoices !== choices) {
        if (!haveGunId && partNumber) {
          updateMeta('', $('#product-meta-model'), $('#itemprop-model'));
          updateMeta('', $('#product-meta-sku'), $('#itemprop-sku'));
          updateMeta('', $('#product-meta-part'), $('#itemprop-part'));
          $('#add-to-cart').text('Check Fit').append(window.app.btnBorder);
          partNumber = false; // this will change the behavior of the form submit
        }
      }

      // first time we find a variant, use this to catch a change later
      // when we have a part number, we need to check for any changes to the selections by the user
      if (!dynamicOptionChoices) {
        dynamicOptionChoices = choices;
      }
    }

    // maybe enable add to cart
    if( currentVariant.available ){
	  	enableAddToCart();
    }else{
		disableAddToCart();
    }

    // stock message no longer responds to variant changes
    // updateStockMessage(currentVariant.id);

    // wishlist App tie in
    let currentProductId = $wishlistBtn.data('product');
    if (currentProductId in iWishlistmain) {
      if (iWishlistmain[currentProductId].indexOf(currentVariant.id.toString()) > -1) {
        $wishlistBtn.attr('disabled', true).text(iwish_added_txt);
      } else {
        $wishlistBtn.attr('disabled', false).text(iwish_add_txt);
      }
    } else {
      $wishlistBtn.attr('disabled', false).text(iwish_add_txt);
    }

    // Handle add-on dropdown options based on variant selection
    if (!$.isEmptyObject(allowedAddOnVariantIds)) {

      // Allowed add-on variants
      if (allowedAddOnVariantIds[addOnVariantId]) {

        // First, deselect add-ons
        $('.add-on-group .option-input').prop('selected', false);

        // And disable add-on options
        $('.add-on-group .option-input').prop('disabled', true);

        // Then enable the allowed add-ons
        $('.add-on-group .option-input').each(function () {
          if (!$(this).attr('value') || allowedAddOnVariantIds[addOnVariantId].includes($(this).attr('value').toString())) {
            $(this).prop('disabled', false);
          }
        });

      }

    }

  });

  // handle keyboard form submits on holster PDPs when the user hasn't been through the finder yet
  // also prevent submits when the product isn't sellable or we're missing a SKU for some reason
  // if we pass these checks, update our dataLayer product with the selections
  $('#product-form').on('submit',function(e){
    if (window.isHolster && !partNumber) {
      if (!haveGunId) {
        e.preventDefault();
        window.location.href = window.location.origin  + '/pages/holster-finder';
      }
    }
    if ($(this).hasClass('no-submit')) {
      e.preventDefault();
    }
    if( !$('#itemprop-sku').val() ) {
      e.preventDefault();
      $('<div class="alert alert-warning">Sorry, this item cannot be added to cart. Please contact us for assistance. <a href="tel:800-347-1200">800.347.1200</a>.</div>').prependTo('#product-form');
    }
	// variant_id on load will be selected or first available, so update to our actual selection
	window.dlProduct.variant_id = $variantSelect.val();
	window.dlProduct.quantity = $('#quantity').val();
	let v = window.variants.find(variant => variant.id == window.dlProduct.variant_id);
	if (v) {
		window.dlProduct.price = v.price / 100;
		window.dlProduct.variant_name = v.title;
	}
	// building reports in GA for holsters specifically
	if (window.isHolster) {
		window.dlProduct.firearm_make = $('#holsterSelectFirearmMake').val();
		window.dlProduct.firearm_model = $('#holsterSelectFirearmModel').val();
		window.dlProduct.light = $('[id^="holsterSelectLight"]').val();
		window.dlProduct.optic = $('[id^="holsterSelectOptic"]').val();
		window.dlProduct.color = $('[data-option-handle="color"] .option').val();
		window.dlProduct.draw_hand = $('[data-option-handle="draw_hand"] .option').val();
		window.dlProduct.finish = $('[data-option-handle="finish"] .option').val();
		window.dlProduct.material = $('[data-option-handle="material"] .option').val();
	}
	dataLayer.push({ "dl_product" : window.dlProduct });
  });

  /*
  Support pre-selected variant
  */
  if (window.selectedVariant) {
    var optionValues = [];
    for (let i = 0; i < variants.length; i++) {
      var variantObj = variants[i];
      if (variantObj.id == window.selectedVariant) {
        // 3+ option products
        if (variantObj.options.length === 1 && variantObj.option1.includes('_') ){
          optionValues = variantObj.option1.split('_');
        } else if (variantObj.options.length) {
          optionValues = variantObj.options;
        }
      }
    }
    for (let i = 0; i < optionValues.length; i++) {
      selectOption($(`[data-option-index="${i}"]`), optionValues[i]);
    }
  }

  /*
  Image Zoom
  */
  let activeGallery = null;
  function setupSlides(gallery){
		let index = gallery.getCurrentIndex();
		index++;
		gallery.currItem.container.ariaLabel = 'slide ' + index + ' of ' + gallery.options.getNumItemsFn();
		setTimeout(function(){
			$('#pswp-image-carousel .pswp__zoom-wrap').each(function(){
				$(this)
					.attr('aria-hidden',true)
					.attr('tabindex', -1)
					.attr('role','group');
			});
			gallery.currItem.container.ariaHidden = false;
			gallery.currItem.container.removeAttribute('tabindex');
		}, 500); // this is a little arbitrary, but we need to wait for the wrap elements to be available
	}

	$('body').on('click', '.zoomable button', function (e) {
		e.preventDefault();
		window.modalTrigger = $(this);
		let pswpElement = $('.pswp')[0];
		let items = window.pswpData;
		let startIndex = $(this).data('index');
		var options = {
			showHideOpacity: true,
			showAnimationDuration: 500,
			loop: true,
			history: false,
			closeOnVerticalDrag: false,
			allowPanToNext: false,
			pinchToClose: false,
			closeEl: true,
			captionEl: false,
			fullscreenEl: false,
			zoomEl: false,
			shareEl: false,
			counterEl: false,
			arrowEl: false,
			preloaderEl: false,
			tapToToggleControls: false,
			index: startIndex,
			errorMsg: '<p class="pswp__error-msg">Error Message..</p>',
			getDoubleTapZoom(e, t) {
				return 1
			}
		}
		var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
		gallery.init();
		setupSlides(gallery);
		gallery.listen('beforeChange', function() {
			setupSlides(gallery);
			$('#pdp-link-to-full').attr('href', gallery.currItem.src); // link to the full image of the current item
		});
		gallery.listen('close', function() {
			window.modalTrigger.focus();
		});
		$('#pdp-link-to-full').attr('href', $(this).data('href')); // link to the full image of the item clicked
		window.helpers.trapFocus('#zoomed-gallery', false);
		activeGallery = gallery;
	});

	$('#zoomed-gallery .modal-close').on('click', function (e) {
		e.preventDefault();
		activeGallery.close();
	});
	$('#zoomed-gallery .prev').on('click', function (e) {
		e.preventDefault();
		activeGallery.prev();
	});
	$('#zoomed-gallery .next').on('click', function (e) {
		e.preventDefault();
		activeGallery.next();
	});

  /*
  Auto-buttonize last link in product description -- TBD if this stays
  */
  var $lastDescriptionEl = $('.detail-panel.primary').children().last();
  var $lastDescriptionLink = $lastDescriptionEl.find('a');
  // have a link at the end of the description and it's the only thing in the <p> (an inline link will be ignored)
  if ($lastDescriptionLink.length && $lastDescriptionEl.contents().length === 1) {
    $lastDescriptionLink.addClass('btn').append(window.app.btnBorder);
  }

  /*
  Size helper
  */
  var setSizeValue = function(size){
    // let $options = $('[data-option-index=' + $('#size-helper').data('for') + ']').find('.option-input');
    $('#size-result').text(size);
	$(`#option-${$('#size-helper').data('for')}`).val(`size-${size}`).trigger('change');
    // $options.each(function(){
    //   let val = $(this).attr('value').split('-')[1]; // get the number after the dash in the group handle
    //   if (val === size) {
    //     $(this).click();
    //     return;
    //   }
    // });
  }
  if ($('#size-helper').length && window.sizeDatasetKey !== '') {
    let keys = Object.keys(window.sizeDataset);
    var helperObj = null;

    keys.forEach(key => {
      let groupKeys = key.split('|');
      groupKeys.forEach(groupKey => {
        if (groupKey === window.sizeDatasetKey) {
          helperObj = sizeDataset[key];
        }
      });
    });

    if (helperObj) {
      // helper markup
      let baseHtml = `<p class="title">Find your size</p><table class="compressed"><thead><tr><th width="10%" class="col-center">Size</th></tr></head><tbody><tr><td id="size-result" class="col-center"></td></tr></tbody></table>`;
      $('#size-helper').html(baseHtml);

      // build the table
      let $table = $('#size-helper .compressed');
      let headings = helperObj.columns.split('|');
      for (let i = headings.length - 1; i >= 0; i--) {
        $table.find('thead tr').prepend('<th>' + headings[i] + '</th>');
        $table.find('tbody tr').prepend(`<td><label for="pouch-selection-${i}" class="sr-only">Select ${headings[i]}</label><select id="pouch-selection-${i}" class="inline"><option value="">Select...</option></select></td>`);
      }

      // populate first select
      let $primarySelection = $('#pouch-selection-0');
      let $secondarySelection = $('#pouch-selection-1');
      let secondarySelectionBase = $secondarySelection.html();
      let options = Object.keys(helperObj.data);

      options.forEach(name => {
        // if there's only one choice, use the value for the key, otherwise use the key as the option's value
        let value = helperObj.data[name];
        if ($secondarySelection.length) {
          value = name;
        }
        $primarySelection.append('<option value="' + value + '">' + name + '</option>');
      });

      // show it
      $('#size-helper').removeClass('d-none');

      // primary select changes
      $primarySelection.on('change', function(){
        let value = $(this).val();
        if ($secondarySelection.length) {
          let options = helperObj.data[value];
          let secondaryValues = Object.keys(options);
          let secondarySelectionHtml = secondarySelectionBase; // reset to inital empty selection when on primary changes
          secondaryValues.forEach(value => {
            secondarySelectionHtml += '<option value="' + options[value] + '">' + value + '</option>';
          });
          $secondarySelection.html(secondarySelectionHtml);
        } else {
          setSizeValue($(this).val());
        }
      });

      // secondary select changes
      $secondarySelection.on('change', function(){
        setSizeValue($(this).val());
      });
    }
  }

  /*
  Attempt to clean up bullets not in a ul
  */
  var $longDesc = $('.long-description');
  var longDescText = $longDesc.text();
  if (!$longDesc.find('ul').length) {
    var $items = $longDesc.find('li');
    // just bullets
    if (!$items.length && longDescText.includes('•')) {
      $longDesc.html('<ul/>')
      var bullets = longDescText.split('•');
      for (let index = 0; index < bullets.length; index++) {
        const item = bullets[index].trim();
        if (item) {
          $longDesc.find('ul').append('<li>' + item + '</li>');
        }
      }
    }
    // unwrapped li's
    if ($items.length){
      $items.wrapAll('<ul />');
    }
  }

  /*
    Compress tables in product details section
  */
  $('.detail-panel table').each(function(){
    // add .scrolling-table so the table can expand to its natural width
    $(this).addClass('compressed striped').wrap('<div class="scrolling-table"></div>');
    // if we don't need it or we're on desktop, unwrap to disable scrolling
    if ($(this).outerWidth() <= $(this).parent().outerWidth() || $(window).width() >= app.breakpoints.lg ){
      $(this).unwrap();
    }
  });

  /*
  Add ons
  */
  $('#add-to-cart').on('click', function(e){
    e.preventDefault();
    $(this).addClass('working');

    // Set add to cart timestamp
    var addedToCartTimestamp = (new Date()).toISOString();
    $(e.target).closest('form').find('#itemprop-added-to-cart-timestamp').val(addedToCartTimestamp);

    if ($('.add-on-item').length || $('.add-on-group').length) {
      $('.add-on-item:checked, .add-on-group .option').each(function(){
        let value = $(this).val();
        let $dataSrc = $(this);
        if ($(this).hasClass('option')) {
          if (!value) {
            return true; // nothing selected, continue
          }
          $dataSrc = $(this).find(`[value="${value}"]`);
        }
        $.get({
          async: false, // send each product one at a time before submitting the form
          url: '/cart/add',
          data: {
            'id' : value,
            'quantity' : $('#quantity').val(),
            'properties[SKU]' : $dataSrc.data('sku'),
            'properties[Model]' : $dataSrc.data('model'),
            'properties[Part]' : $dataSrc.data('part'),
            'properties[*QuickShip]' : $dataSrc.data('quick-ship'),
            'properties[*LastChance]' : $dataSrc.data('last-chance'),
            'properties[*Promotion]' : $dataSrc.data('promotion'),
            'properties[*Shipping]' : $dataSrc.data('shipping'),
            'properties[*Shipping Days]' : $dataSrc.data('shipping-days'),
            'properties[*Added To Cart Timestamp]' : addedToCartTimestamp,
          },
          success: function(data, textStatus, jqXHR){
            if (textStatus !== 'success'){
              console.log(data)
            }
          }
        });
      });
    }
    $('#product-form').submit();
  });

  $('#pdp-details-jump').on('click', function(e){
    e.preventDefault();
    var $target = $($(this).attr('href'));
    $("html, body").animate({ scrollTop: $target.offset().top - $('#site-header').outerHeight() }, 1000);
  });

	// if we landed here after a search, store the search details to the page
	// if we come back to the page later, we can attribute the add to cart conversion back to algolia.
	let queryId = window.helpers.getAlgoliaQueryIdFromCurrentUrl();
	if (queryId) {
		const url = new URL(window.location.href);
		const searchParams = url.searchParams;
		const data = {
			query : queryId,
			index : searchParams.get('queryIndex'),
			object : searchParams.get('objectID')
		};
		sessionStorage.setItem('aa-' + window.productHandle, JSON.stringify(data));
	}

}